"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var app_1 = require("firebase/app");
var functions_1 = require("firebase/functions");
var firestore_1 = require("firebase/firestore");
var errorHandler_1 = __importDefault(require("../errorHandler"));
var WebhookController = /** @class */ (function () {
    /**
     * @param {FirebaseOptions} config Firebase configuration to initialize app.
     */
    function WebhookController(config) {
        var _this = this;
        /**
         * Creates a webhook for merchant
         * @async
         * @param params.merchantId the merchant id
         * @param params.WebhookTopic the topic of the webhook
         * @param params.webhook  partial MerchantWebhook data
         * @returns the created merchant id
         */
        this.create = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.create(params)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Deletes a merchants webhook
         * @async
         * @param params.id contains the id of merchant for whom we want to delete the webhook of
         * @returns the id of the merchant the webhook was deleted from
         */
        this.deleteOne = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions["delete"](params)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, { data: params.id }];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_2)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Updates the status and/or notificationUrl of a merchants webhook
         * @async
         * @param params.merchantId the merchant id
         * @param params.WebhookTopic the topic of the webhook
         * @param params.webhook  partial MerchantWebhook data
         * @returns void if successful
         */
        this.update = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.functions.update(params)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2:
                        err_3 = _a.sent();
                        return [2 /*return*/, (0, errorHandler_1["default"])(err_3)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var firebaseApp = (0, app_1.initializeApp)(config);
        var firebaseFunctions = (0, functions_1.getFunctions)(firebaseApp);
        this.db = (0, firestore_1.getFirestore)(firebaseApp);
        this.functions = {
            create: (0, functions_1.httpsCallable)(firebaseFunctions, "webhooks-createWebhook"),
            update: (0, functions_1.httpsCallable)(firebaseFunctions, "webhooks-updateWebhook"),
            "delete": (0, functions_1.httpsCallable)(firebaseFunctions, "webhooks-deleteWebhook")
        };
    }
    return WebhookController;
}());
exports["default"] = WebhookController;
